module.exports = __webpack_public_path__ + "img/b8411e7.jpg";